import { disconnect } from 'common/sockets/ocr';

export default () => disconnect();
